// extracted by mini-css-extract-plugin
export default {"controls":"PlaybackControls_controls__oIFbV"};